import { useCurrentStateAndParams } from "@uirouter/react";

import { Flex } from "@similarweb/ui-components/foundations";

import { getEducationData, useCurrentPageState } from "app/components/educationbar/education-utils";
import { WEBSITE_ANALYSIS_PERFORMANCE } from "app/pages/sales-intelligence/constants/routes";
import websiteAnalysisStorage from "app/pages/sales-intelligence/modules/website-analysis/services/storage/storage";
import HelpButton from "app/pages/sales-intelligence/pages/company-analysis/components/shared/HelpButton/HelpButton";
import PageHeaderBreadcrumbs from "app/pages/sales-intelligence/pages/company-analysis/containers/header/PageHeaderBreadcrumbs/PageHeaderBreadcrumbs";
import PDFComponent from "app/pages/sales-intelligence/pages/company-analysis/containers/header/PDFComponent/PDFComponent";
import { useEducationBarState } from "app/pages/sales-intelligence/sub-modules/education-bar";
import EducationBarContainer from "app/pages/sales-intelligence/sub-modules/education-bar/containers/EducationBarContainer";
import { isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { TRIAL_BANNER_HEIGHT } from "app/components/React/TrialBanner/StyledTrialBanner";
import type { ISubNavProps } from "app/components/sub-navigation-bar/SubNav";
import { SubNav } from "app/components/sub-navigation-bar/SubNav";
import WebsiteAnalysisFilters from "app/pages/website-analysis/WebsiteAnalysisFilters";

import { StyledPageHeader } from "./styles";

type PageHeaderProps = Omit<ISubNavProps, "topLeftComponent, topRightComponent">;

const WebsitePageHeader = (props: PageHeaderProps) => {
    const educationId = useCurrentPageState();
    const { state } = useCurrentStateAndParams();
    const hasEducationData = getEducationData(educationId);
    const isTrialBannerVisible = isTrialOrAfterTrial();

    const { isBarVisible, onClose, onOpen } = useEducationBarState(websiteAnalysisStorage);

    const renderEducationBar = () => {
        if (!isBarVisible || !hasEducationData) {
            return null;
        }

        return (
            <EducationBarContainer
                onClose={onClose}
                stateId={educationId || ""}
            />
        );
    };

    return (
        <div className="hidden-print">
            <StyledPageHeader topOffset={isTrialBannerVisible ? TRIAL_BANNER_HEIGHT : 0}>
                <SubNav
                    {...props}
                    topLeftComponent={<PageHeaderBreadcrumbs isDomainBreadcrumbVisible />}
                    topRightComponent={
                        <Flex
                            alignItems="center"
                            gap="8px"
                            padding="0 60px 0 0"
                        >
                            {state.stateId === WEBSITE_ANALYSIS_PERFORMANCE ? <PDFComponent /> : null}
                            {isBarVisible || !hasEducationData ? null : <HelpButton onClick={onOpen} />}
                            <WebsiteAnalysisFilters />
                        </Flex>
                    }
                    education={renderEducationBar()}
                />
            </StyledPageHeader>
        </div>
    );
};

export default WebsitePageHeader;
